import { render, staticRenderFns } from "./EligibilityRequestRenderModal.vue?vue&type=template&id=70d78134&scoped=true&"
import script from "./EligibilityRequestRenderModal.vue?vue&type=script&lang=js&"
export * from "./EligibilityRequestRenderModal.vue?vue&type=script&lang=js&"
import style0 from "./EligibilityRequestRenderModal.vue?vue&type=style&index=0&id=70d78134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d78134",
  null
  
)

export default component.exports